export default __webpack_public_path__ + "static/media/cadence.e41fad53.svg";